'use strict';

const hasSymbol = typeof Symbol === 'function' && Symbol.for;
var nested = hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__';

module.exports = nested;
//# sourceMappingURL=nested.cjs.map
